import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Row, Col } from "react-bootstrap";
import { fetchBranding, updatedSideOrBottmeAppMenu } from "BrandingAction";
import { fetchSettings } from "TicketAction";
import { fetchFeature } from "GeneralTabAction";
import { screenHeightLeftFromTop } from "Constants";
import AppBottomMenu from "../app-bottom-menu";

class Appmenu extends Component {
  constructor(props) {
    super(props);
    this.brandingRef = React.createRef();
    this.webbrandingRef = React.createRef();
    this.submit = this.submit.bind(this);
    this.themeRef = React.createRef();
    this.webthemeRef = React.createRef();
    this.appMenuRef = React.createRef();
    this.myRef = React.createRef();
  }

  componentDidMount() {
    this.props.fetchFeature(this.props.session);
    this.props.updatedSideOrBottmeAppMenu({
      sidemenu: false,
      bottommenu: false,
    });
    this.props.fetchSettings(this.props.session);
    setTimeout(() => {
      // this.props.fetchBranding(this.props.session);
    }, 400);
  }

  submit() {
    // let { totalAppModules } = this.props;
    // let website = _.filter(totalAppModules, function (o) {
    //   return o.bsClass === "website";
    // });
    // if (website && website.length > 0 && website[0].isenabled) {
    //   this.themeRef.current.closePicker();
    //   this.brandingRef.current.wrappedInstance.submitBrandingData();
    //   this.webthemeRef.current.closeWebPicker();
    //   this.webbrandingRef.current.wrappedInstance.submitBrandingData();
    //   this.appMenuRef.current.submitBrandingData();
    // } else {
    //   this.themeRef.current.closePicker();
    //   this.brandingRef.current.wrappedInstance.submitBrandingData();
    //   this.appMenuRef.current.submitBrandingData();
    // }
    this.appMenuRef.current.submitBrandingData();
  }

  render() {
    let { session, deviceSize, totalAppModules, mergerArray, appMenu } =
      this.props;

    return (
      <div
        className="panel-body scrollable-content"
        style={{ height: deviceSize.height - screenHeightLeftFromTop }}
      >
        <Row>
          <Col md={12} style={{ paddingLeft: 6 }}>
            {mergerArray.length > 0 && appMenu.length > 0 ? (
              <AppBottomMenu
                submitBrandingDataHandler={this.props.submitBrandingDataHandler}
                ref={this.appMenuRef}
                history={this.props.history}
              />
            ) : (
              ""
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    deviceSize: state.deviceSize,
    totalAppModules: state.totalAppModules,
    mergerArray: state.contentDisplayItems,
    appMenu: state.appBottomMenu,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchFeature,
    fetchBranding,
    fetchSettings,
    updatedSideOrBottmeAppMenu,
  },
  null,
  { forwardRef: true }
)(Appmenu);
